import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Home from './pages/Home';
import CityPage from './pages/CityPage';
import ServiceCityPage from './pages/ServiceCityPage';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
import PostGenerator from './pages/PostGenerator';
import JobberAdmin from './pages/JobberAdmin';

function App() {
  return (
    <div className="App bg-ink min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/company" element={<Home />} />
          <Route path="/fence-contractor/:citySlug" element={<CityPage />} />
          <Route path="/services/:serviceSlug/:citySlug" element={<ServiceCityPage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/admin/post" element={<PostGenerator />} />
          <Route path="/admin/jobber" element={<JobberAdmin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
